import { useCan } from "modules/settings/accessRoles";
import {
  Button,
  ButtonGroup,
  Box,
  Card as MuiCard,
  CardContent,
  CircularProgress as MuiCircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import StatusTag from "../../apl/components/StatusTag";
import { makeStyles } from "@mui/styles";
import { Search as SearchIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import {
  EditableTable,
  newConditionalOnSelectButton,
  newFieldLinkUrl,
} from "../../../components/EditableTable";
import { setSnackbar } from "../../snackbar/api/snackbar";
import {
  deleteByUuid,
  get as getAccountDisconnects,
  processDisconnects,
} from "../api/actions";
import axios from "axios";
import { AccountDisconnectsQueryType } from "../helpers/enums";
import ExistingAccountDisconnectForm from "./EditForm";
import Form from "./Form";

const CircularProgress = styled(MuiCircularProgress)(spacing);
const Card = styled(MuiCard)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function Table(props) {
  const canDisconnect = useCan()("disconnects");
  const useStyles = makeStyles((theme) => ({
    active: {
      fontWeight: "bold",
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.primary.contrastText} !important`,
      borderColor: `${theme.palette.primary.main} !important`,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.dark} !important`,
        borderColor: `${theme.palette.primary.dark} !important`,
      }
    },
    inactive: {
      fontWeight: "bold",
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(0, 51, 102, 0.04)',
      }
    },
  }));

  const classes = useStyles();

  const getDisconnectTypeChipStyle = (type) => {
    if (disconnectsQueryType === type) {
      return {
        backgroundColor: "#1976d2",
        color: "#ffffff !important",
        border: "1px solid #1976d2",
        fontWeight: 500,
        borderRadius: "16px",
        fontSize: "0.875rem",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#1565c0",
          border: "1px solid #1565c0",
        }
      };
    }
    return {
      backgroundColor: "rgba(158, 158, 158, 0.1)",
      color: "#757575 !important",
      border: "1px solid #bdbdbd",
      fontWeight: 500,
      borderRadius: "16px",
      fontSize: "0.875rem",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "rgba(158, 158, 158, 0.2)",
        border: "1px solid #bdbdbd",
      }
    };
  };

  const getStatusChipStyle = (status) => {
    if (disconnectStatusQueryType === status) {
      return {
        backgroundColor: "#1976d2",
        color: "#ffffff !important",
        border: "1px solid #1976d2",
        fontWeight: 500,
        borderRadius: "16px",
        fontSize: "0.875rem",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#1565c0",
          border: "1px solid #1565c0",
        }
      };
    }
    return {
      backgroundColor: "rgba(158, 158, 158, 0.1)",
      color: "#757575 !important",
      border: "1px solid #bdbdbd",
      fontWeight: 500,
      borderRadius: "16px",
      fontSize: "0.875rem",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "rgba(158, 158, 158, 0.2)",
        border: "1px solid #bdbdbd",
      }
    };
  };

  const getAccountTypeChipStyle = (type) => {
    if (disconnectAccountQueryType === type) {
      return {
        backgroundColor: "#1976d2",
        color: "#ffffff !important",
        border: "1px solid #1976d2",
        fontWeight: 500,
        borderRadius: "16px",
        fontSize: "0.875rem",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#1565c0",
          border: "1px solid #1565c0",
        }
      };
    }
    return {
      backgroundColor: "rgba(158, 158, 158, 0.1)",
      color: "#757575 !important",
      border: "1px solid #bdbdbd",
      fontWeight: 500,
      borderRadius: "16px",
      fontSize: "0.875rem",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "rgba(158, 158, 158, 0.2)",
        border: "1px solid #bdbdbd",
      }
    };
  };

  const [disconnectsQueryType, setDisconnectsQueryType] = React.useState(
    AccountDisconnectsQueryType.FOURTEEN_DAY
  );
  const [disconnectStatusQueryType, setDisconnectStatusQueryType] = React.useState("Active");
  const [disconnectAccountQueryType, setDisconnectAccountQueryType] = React.useState("Management Co")
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchQuery, setSearchQuery] = React.useState(
    props.account.data.account && props.isAccountPage
      ? props.account.data.account.accountNum
      : ""
  ); // should be all thats needed to reduce the disconnects shown to only that accounts

  const [property, setProperty] = React.useState(null);
  const [propertyName, setPropertyName] = React.useState(null);
  const [resetCachedData, setResetCachedData] = React.useState(true);
  const [selectedDisconnectIndex, setselectedDisconnectIndex] =
    React.useState(null);
  const [display, setDisplay] = React.useState(false);
  const [displayEditModel, setDisplayEditModel] = React.useState(false);
  const [displayProcessFinalNoticeModel, setDisplayProcessFinalNoticeModel] =
    React.useState(false);
  const [itemsToProcess, setItemsToProcess] = React.useState([]);
  const [disconnectDate, setDisconnectDate] = React.useState(null);
  const [focus, setFocus] = React.useState(false);

  const dispatch = useDispatch();

  const CurrentLookupTypeButton = () => {
    return (
      <IconButton>
        <SearchIcon mr={2} />
      </IconButton>
    );
  };

  const setSearchFocus = () => {
    setFocus(true);
  }
  const unsetSearchFocus = () => {
    setFocus(false);
  }
  const SearchBar = () => {
    return (
      <>
        {focus ?
          <TextField
            id={"searchTarget"}
            label="Search Disconnects"
            type={"text"}
            placeholder={"account holder name, number..."}
            onChange={handleSearchQueryInput}
            autoFocus={true}
            onBlur={unsetSearchFocus}
            name={"searchTarget"}
            defaultValue={searchQuery}
            fullWidth
            my={2}
            size={"small"}
            variant={"outlined"}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
          ></TextField>
          :
          <TextField
            id={"searchTarget"}
            label="Search Disconnects"
            type={"text"}
            placeholder={"account holder name, number..."}
            onChange={handleSearchQueryInput}
            onClick={setSearchFocus}
            name={"searchTarget"}
            defaultValue={searchQuery}
            fullWidth
            my={2}
            size={"small"}
            variant={"outlined"}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
          ></TextField>
        }
      </>
    );
  };

  // Table Stuff:
  // Account Holder 	Address 	Meter Info 	Letter Sent Dates 	Disconnect Date 	Last Paid 	Disconnect Amt 	Account Balance
  const fieldTitles = [
    "Account Holder",
    "Status",
    "Type",
    "Property",
    "Address",
    "Meter Info",
    "Letter Sent Dates (Type)",
    "Disconnect Date",
    "Last Paid",
    "Disconnect Amt",
    "Account Balance",
  ];
  const fieldTypes = [
    ["labelSmall", "labelSmall"],
    "labelSmall",
    "labelSmall",
    ["labelSmall", "labelSmall"],
    ["labelSmall", "labelSmall"],
    "labelSmall",
    ["labelSmall", "labelSmall", "labelSmall", "labelSmall"],
    "labelSmall",
    "dateLabelSmall",
    "moneyLabel",
    ["moneyLabel", "label"],
  ];
  const fieldNames = [
    ["fullName", "accountNum"],
    "AccountStatus",
    "AccountType",
    ["propertyName", "pmName"],
    ["address1", "address2"],
    "meterNum",
    [
      "letter14DaySentDate",
      "letter10DaySentDate",
      "letterFinalNoticeSentDate",
      "letterDisconnectSentDate",
    ],
    "disconnectDate",
    "lastPaymentDate",
    "pastDue",
    ["accountBalance", "accountStatuses"],
  ];

  const accountPage_fieldTitles = [
    "ID",
    "14-DAY LETTER DATE",
    "10-DAY LETTER DATE",
    "FINAL NOTICE LETTER DATE",
    "DISCONNECT NOTICE DATE",
    "DISCONNECT DATE",
    "STATUS"
  ];
  const accountPage_fieldTypes = [
    "labelSmall",
    "label",
    "label",
    "label",
    "label",
    "label",
    "label",
  ];
  const accountPage_fieldNames = [
    "id",
    "letter14DaySentDate",
    "letter10DaySentDate",
    "letterFinalNoticeSentDate",
    "letterDisconnectSentDate",
    "disconnectDate",
    "disconnectStatus"
  ];

  // Used for form refreshing after completion
  const onUpdate = () => {
    hide();
    getAccountDisconnects();
  };

  const show = () => {
    setDisplay(true);
  };

  const hide = () => {
    setDisplay(false);
  };

  const onUpdateEditExistingDialog = () => {
    hideEditExistingDialog();
    //getAccountDisconnects();
  };

  const showEditExistingDialog = () => {
    setDisplayEditModel(true);
  };

  const hideEditExistingDialog = () => {
    setDisplayEditModel(false);
    setselectedDisconnectIndex(null);
  };

  const showProcessFinalNoticeDialog = (items) => {
    setItemsToProcess(items);
    setDisplayProcessFinalNoticeModel(true);
  };

  const hideProcessFinalNoticeDialog = () => {
    setDisplayProcessFinalNoticeModel(false);
  };

  const handleChangeRowsPerPage = (rowsPerPage) => {
    setResetCachedData(false);
    setRowsPerPage(rowsPerPage);
  };

  const handleChangePage = (page) => {
    setResetCachedData(false);
    setPage(page);
  };

  const handleSelectedPropertyChange = (event) => {
    setPage(0);
    setResetCachedData(true);
    if (event.target.value == "" || event.target.value == null) {
      setPropertyName(null);
    }
    else {
      var target = props.apl.data.propertyPreviews.find(x => x.uuid === event.target.value);
      setPropertyName(target.name);
    }
    setProperty(event.target.value);
  };
  const handleActiveTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectStatusQueryType('Active');
  }
  const handleInActiveTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectStatusQueryType('Inactive');
  }
  const handleAllTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectStatusQueryType(null);
  }

  const handleAllAccountTypeTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectAccountQueryType(null)
  }

  const handlePMAccountTypeTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectAccountQueryType('Management Co');
  }
  const handleTenantAccountTypeTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectAccountQueryType('Tenant');
  }
  const handleCommonAccountTypeTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectAccountQueryType('Common Area');
  }

  const handleSearchQueryInput = (event) => {
    setPage(0);
    setResetCachedData(true);
    setSearchQuery(event.target.value);
  };

  const handleTenDayTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.TEN_DAY);
  };

 

  const handleStartedTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.STARTED);
  };


  const handleFourteenDayTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.FOURTEEN_DAY);
  };

  const handleFinalNoticeReadyTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.FINAL_READY);
  };

  const handleFinalNoticeProcessingTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.SENDING_FINAL);
  };

  const handleDisconnectReadyTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.DISCONNECT_POST_READY);
  };

  const handleDisconnectProcessingTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.SENDING_DISCONNECT);
  };

  const handleDisconnectedTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.DISCONNECT_POSTED);
  };

  const handleCompletedTabClick = () => {
    setPage(0);
    setResetCachedData(true);
    setDisconnectsQueryType(AccountDisconnectsQueryType.COMPLETED);
  };

  const deleteSelectedDisconnects = (disconnects) => {
    dispatch(setSnackbar(true, "warning", "Deleting Disconnects..."));
    console.log('deleteSelectedDisconnects');
    console.log(disconnects);
    disconnects.map((disconnectUuid) => {
      console.log(disconnectUuid);
      props.deleteByUuid(disconnectUuid, false).then(() => {
        if (!props.accountDisconnects.accountDisconnectIsLoading) {
          getAccountDisconnects();
        }
        if (props.accountDisconnects.error != null) {
          dispatch(setSnackbar(true, "error", "Error Deleting Disconnect!"));
        }
        else {
          dispatch(setSnackbar(true, "success", "Disconnect Deleted"));
        }
      });
    });
  };

  const handleProcessDisconnectsClick = (items, disconnectDate = null) => {
    setResetCachedData(true);
    var uuids = [];
    for (let index = 0; index < items.length; index++) {
      const uuid = items[index].uuid;
      uuids.push(uuid);
    }
    dispatch(setSnackbar(true, "warning", "Processing Disconnects..."));
    props.processDisconnects(uuids, disconnectDate, disconnectsQueryType).then(() => {
      getAccountDisconnects();
      if (props.accountDisconnects.error != null) {
        dispatch(
          setSnackbar(
            true,
            "error",
            "Error Processing Disconnect"
          )
        );
      }
      else {
        dispatch(
          setSnackbar(
            true,
            "success",
            "Disconnect Letters Process Sucessfully Started!"
          )
        );
      }

    });
  };

  // Should open a tab to a account disconnect details page
  const onSelected = (item) => { };

  const onEditablePropertySelected = (item) => {
    for (
      var x = 0;
      x < props.accountDisconnects.data.accountDisconnectsList.items.length;
      x++
    ) {
      if (
        props.accountDisconnects.data.accountDisconnectsList.items[x].id ==
        item.id
      ) {
        setselectedDisconnectIndex(x);
        x = props.accountDisconnects.data.accountDisconnectsList.items.length;
      }
    }
    showEditExistingDialog();
    return null;
  };

  const EditExistingDialog = (props) => {
    return (
      <Dialog
        open={displayEditModel}
        TransitionComponent={Transition}
        fullWidth={"lg"}
        maxWidth={"lg"}
        keepMounted
        onClose={hideEditExistingDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {!props.accountDisconnects.isLoading &&
          props.disconnectIndex != null &&
          props.disconnectIndex <
          props.accountDisconnects.data.accountDisconnectsList.items.length &&
          props.disconnectIndex <
          props.accountDisconnects.data.accountDisconnectsList.items.length ? (
          <>
            <DialogTitle id="alert-dialog-slide-title">
              Edit Account Disconnect:{" "}
              {
                props.accountDisconnects.data.accountDisconnectsList.items[
                  props.disconnectIndex
                ].fullName
              }
              ,{" "}
              {
                props.accountDisconnects.data.accountDisconnectsList.items[
                  props.disconnectIndex
                ].accountEmail
              }
            </DialogTitle>
            <DialogContent>
              <ExistingAccountDisconnectForm
                accountDisconnects={props.accountDisconnects}
                disconnectIndex={props.disconnectIndex}
                onUpdate={onUpdateEditExistingDialog}
                onCancel={hideEditExistingDialog}
              />
            </DialogContent>
          </>
        ) : (
          <DialogTitle id="alert-dialog-slide-title">
            Edit Account Disconnect: UNKNOWN
          </DialogTitle>
        )}
      </Dialog>
    );
  };

  const SetFinalNoticeDisconnectDateDialog = (props) => {
    return (
      <Dialog
        open={displayProcessFinalNoticeModel}
        TransitionComponent={Transition}
        fullWidth={"lg"}
        maxWidth={"lg"}
        keepMounted
        onClose={hideProcessFinalNoticeDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          Process Final Notices
        </DialogTitle>
        <DialogContent>
          <Card mb={6} elevation={3}>
            <CardContent>
              <Grid container spacing={4}>
                <Grid item lg={4} md={12} sm={12}>
                  <TextField
                    id="disconnectDate"
                    label="Disconnect Date"
                    type="date"
                    fullWidth
                    my={2}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(event) => {
                      setDisconnectDate(event.target.value);
                    }}
                    defaultValue={disconnectDate}
                    name="disconnectDate"
                  />
                </Grid>
              </Grid>
              <Grid container item spacing={2} justify={"flex-end"}>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleProcessDisconnectsClick(
                        props.items,
                        disconnectDate
                      );
                      hideProcessFinalNoticeDialog();
                    }}
                    color="secondary"
                  >
                    Process
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={hideProcessFinalNoticeDialog}
                    color="primary"
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
    );
  };

  /*
  const handleProcessFinalNoticeClick = (items) => {
    setResetCachedData(true);
    var uuids = [];
    for (let index = 0; index < items.length; index++) {
      const uuid = items[index].uuid;
      uuids.push(uuid);
    }
    dispatch(setSnackbar(true, "warning", "Processing Final Notices..."));
    props.processFinalNotices(uuids).then(()=>{
      getAccountDisconnects();
      dispatch(setSnackbar(true, "success", "Final Notices Process Sucessfully Started!"));
    });
  };*/

  const getAccountDisconnects = () => {
    if (props.isAccountPage && props.accountNum) {
      props.getAccountDisconnects(
        page,
        rowsPerPage,
        AccountDisconnectsQueryType.ALL,
        props.accountNum,
        true,
        resetCachedData,
        property,
      );
    } else {
      props.getAccountDisconnects(
        page,
        rowsPerPage,
        disconnectsQueryType,
        searchQuery,
        true,
        resetCachedData,
        property,
        disconnectStatusQueryType,
        disconnectAccountQueryType
      );
    }
  };

  useEffect(() => {
    if ((page + 1) * rowsPerPage > props.accountDisconnects.data.accountDisconnectsList.items.length || resetCachedData) {
      getAccountDisconnects();
    }
  }, [page, property, rowsPerPage, disconnectsQueryType, searchQuery, disconnectStatusQueryType, disconnectAccountQueryType]);

  const Filters = () => {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Button
          onClick={handleStartedTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.STARTED)}
          variant="outlined"
          size="small"
        >
          Started
        </Button>
        <Button
          onClick={handleFourteenDayTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.FOURTEEN_DAY)}
          variant="outlined"
          size="small"
        >
          14 DAY
        </Button>
        <Button
          onClick={handleTenDayTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.TEN_DAY)}
          variant="outlined"
          size="small"
        >
          10 DAY
        </Button>
        <Button
          onClick={handleFinalNoticeReadyTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.FINAL_READY)}
          variant="outlined"
          size="small"
        >
          FINAL NOTICE READY
        </Button>
        <Button
          onClick={handleFinalNoticeProcessingTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.SENDING_FINAL)}
          variant="outlined"
          size="small"
        >
          FINAL NOTICE PROCESSING
        </Button>
        <Button
          onClick={handleDisconnectReadyTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.DISCONNECT_POST_READY)}
          variant="outlined"
          size="small"
        >
          DISCONNECT POST READY
        </Button>
        <Button
          onClick={handleDisconnectProcessingTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.SENDING_DISCONNECT)}
          variant="outlined"
          size="small"
        >
          DISCONNECT PROCESSING
        </Button>
        <Button
          onClick={handleDisconnectedTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.DISCONNECT_POSTED)}
          variant="outlined"
          size="small"
        >
          DISCONNECTED
        </Button>
        <Button
          onClick={handleCompletedTabClick}
          sx={getDisconnectTypeChipStyle(AccountDisconnectsQueryType.COMPLETED)}
          variant="outlined"
          size="small"
        >
          COMPLETED
        </Button>
      </Box>
    );
  };

  const letterUrl = (item) => {
    return item.letterUrl;
  };

  const accountUrl = (item) => {
    return `/accountmanager/${item.accountNum}/${item.accountUuid}`;
  };

  const disconnectDetailUrl = (item) => {
    return `/disconnect/${item.uuid}`;
  };

  const openLetterById = (letterId) => {
    if (!letterId) return;
    axios.get(`/letters/${letterId}`).then(res => {
      if (res.data && res.data.url) {
        window.open(res.data.url);
      }
    }).catch(err => {
      console.error("Error fetching letter:", err);
    });
  };

  const letter14DaySentDateLetterUrl = (item) => {
    if (item.letter14DayId != null) {
      openLetterById(item.letter14DayId);
    }
    return null;
  };

  const letter10DaySentDateLetterUrl = (item) => {
    if (item.letter10DayId != null) {
      openLetterById(item.letter10DayId);
    }
    return null;
  };

  const letterFinalNoticeSentDateLetterUrl = (item) => {
    if (item.letterFinalNoticeId != null) {
      openLetterById(item.letterFinalNoticeId);
    }
    return null;
  };

  const letterDisconnectSentDateLetterUrl = (item) => {
    if (item.letterDisconnectId != null) {
      openLetterById(item.letterDisconnectId);
    }
    return null;
  };

  const urlFields = [
    newFieldLinkUrl("id", disconnectDetailUrl),
    newFieldLinkUrl("letter14DaySentDate", letter14DaySentDateLetterUrl),
    newFieldLinkUrl("letter10DaySentDate", letter10DaySentDateLetterUrl),
    newFieldLinkUrl(
      "letterFinalNoticeSentDate",
      letterFinalNoticeSentDateLetterUrl
    ),
    newFieldLinkUrl(
      "letterDisconnectSentDate",
      letterDisconnectSentDateLetterUrl
    ),
    newFieldLinkUrl("fullName", accountUrl),
    newFieldLinkUrl("accountNum", accountUrl),

    newFieldLinkUrl("disconnectDate", onEditablePropertySelected),
    newFieldLinkUrl("disconnectAmt", onEditablePropertySelected),
  ];

  const ConditionalOnSelectButtons = [
    newConditionalOnSelectButton(
      "Process Final Notice",
      () => {
        return disconnectsQueryType == AccountDisconnectsQueryType.FINAL_READY;
      },
      showProcessFinalNoticeDialog
    ),
    newConditionalOnSelectButton(
      "Process Disconnect Notice",
      () => {
        return (
          disconnectsQueryType ==
          AccountDisconnectsQueryType.DISCONNECT_POST_READY
        );
      },
      handleProcessDisconnectsClick
    ),
  ];

  function isToday(dateParameter) {
    var today = new Date();
    if (!dateParameter || dateParameter == "N/A") return false;
    var d = dateParameter.split("/");
    var newDate = new Date(d[2], d[0] - 1, d[1]);
    return (
      newDate.getDate() === today.getDate() &&
      newDate.getMonth() === today.getMonth() &&
      newDate.getFullYear() === today.getFullYear()
    );
  }

  const StatusFilters = () => {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Button
          onClick={handleAllTabClick}
          sx={getStatusChipStyle(null)}
          variant="outlined"
          size="small"
        >
          All
        </Button>
        <Button
          onClick={handleActiveTabClick}
          sx={getStatusChipStyle("Active")}
          variant="outlined"
          size="small"
        >
          Active
        </Button>
        <Button
          onClick={handleInActiveTabClick}
          sx={getStatusChipStyle("Inactive")}
          variant="outlined"
          size="small"
        >
          In Active
        </Button>
      </Box>
    );
  };

  const AccountTypeFilters = () => {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Button
          onClick={handleAllAccountTypeTabClick}
          sx={getAccountTypeChipStyle(null)}
          variant="outlined"
          size="small"
        >
          All
        </Button>
        <Button
          onClick={handlePMAccountTypeTabClick}
          sx={getAccountTypeChipStyle("Management Co")}
          variant="outlined"
          size="small"
        >
          PM
        </Button>
        <Button
          onClick={handleTenantAccountTypeTabClick}
          sx={getAccountTypeChipStyle("Tenant")}
          variant="outlined"
          size="small"
        >
          Tenant
        </Button>
        <Button
          onClick={handleCommonAccountTypeTabClick}
          sx={getAccountTypeChipStyle("Common Area")}
          variant="outlined"
          size="small"
        >
          Common
        </Button>
      </Box>
    );
  };


  const conditionalStyling = (item) => {

    item.AccountStatus = <><StatusTag type={"accountStatus"} isLoading={props.accountDisconnects.isLoading} typeId={item.accountStatusId} showTitle={false} condensed={true} /></>
    // item.customerTypeId = disconnectAccountQueryType !== "Common Area" ? item.customerTypeId : item.customerTypeId = 3
    item.AccountType = <div style={{
      display: "flex",
      flexDirection: 'column',
      justifyContent: "center",
      alignItems: "center",
      gap: "5px"}}>
      {disconnectAccountQueryType === "Common Area" &&
        <StatusTag type={"customerType"} isLoading={props.accountDisconnects.isLoading} typeId={3} showTitle={false}
                   condensed={true}/>}
      <StatusTag type={"customerType"} isLoading={props.accountDisconnects.isLoading} typeId={item.customerTypeId} showTitle={false} condensed={true} />

    </div>

    // Inline formatting removing null from customer name if it exists:

    if (item.letter10DaySentDate != "N/A" && item.letter10DaySentDate != "") {
      if (!item.letter10DaySentDate.includes("(")) {
        item.letter10DaySentDate = `(10) ${item.letter10DaySentDate}`;
      }
    } else {
      item.letter10DaySentDate = "";
    }

    if (item.letter14DaySentDate != "N/A" && item.letter14DaySentDate != "") {
      if (!item.letter14DaySentDate.includes("(")) {
        item.letter14DaySentDate = `(14) ${item.letter14DaySentDate}`;
      }
    } else {
      item.letter14DaySentDate = "";
    }

    if (
      item.letterFinalNoticeSentDate != "N/A" &&
      item.letterFinalNoticeSentDate != ""
    ) {
      if (!item.letterFinalNoticeSentDate.includes("(")) {
        item.letterFinalNoticeSentDate = `(F) ${item.letterFinalNoticeSentDate}`;
      }
    } else {
      item.letterFinalNoticeSentDate = "";
    }

    if (
      item.letterDisconnectSentDate != "N/A" &&
      item.letterDisconnectSentDate != ""
    ) {
      if (!item.letterDisconnectSentDate.includes("(")) {
        item.letterDisconnectSentDate = `(D) ${item.letterDisconnectSentDate}`;
      }
    } else {
      item.letterDisconnectSentDate = "";
    }
    if (isToday(item.disconnectDate)) {
      return { backgroundColor: "lightyellow" };
    }
    if (item.completed == 0) {
      item.status = <StatusTag type={"Alert"} label={"Incomplete"} condensed={true} />
    }
    else if (item.completed == 1) {
      item.status = <StatusTag label={"Completed"} condensed={true} />
    }

    item.accountStatuses =
      <>
        {item.accountPledgeAccount && item.accountPledgeAccount == 1 ?
          <StatusTag type={"Alert"} label={"Pledge Account"} condensed={true} />
          :
          <></>
        }
        {item.accountPaymentPlan && item.accountPaymentPlan == 1 ?
          <StatusTag type={"Alert"} label={"Payment Plan"} condensed={true} />
          :
          <></>
        }
      </>;


    return {};
  };
  return (
    <Card mb={6} elevation={3}>
      <CardContent>
        <Dialog
          open={display}
          TransitionComponent={Transition}
          fullWidth={"lg"}
          maxWidth={"lg"}
          keepMounted
          onClose={hide}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            New Account Disconnect
          </DialogTitle>
          <DialogContent>
            <Form isOpen={display} onUpdate={onUpdate} onCancel={hide} isAccountPage={props.isAccountPage} />
          </DialogContent>
        </Dialog>
        <EditExistingDialog
          accountDisconnects={props.accountDisconnects}
          disconnectIndex={selectedDisconnectIndex}
        />
        <SetFinalNoticeDisconnectDateDialog items={itemsToProcess} />
        {!props.isAccountPage && (
          <>
            {/* Search Bar Section */}
            <Box sx={{ mb: 3 }}>
              <SearchBar />
            </Box>

            {/* Filter Section with Background */}
            <Box sx={{ 
              backgroundColor: '#f5f5f5', 
              borderRadius: 2, 
              p: 3, 
              mb: 3,
              border: '1px solid #e0e0e0'
            }}>
              {/* Disconnect Type Filters Row */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#666' }}>
                  Disconnect Status
                </Typography>
                <Filters />
              </Box>

              {/* Account Type and Status Filters Row */}
              <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', mb: 2 }}>
                <Box sx={{ flex: 1, minWidth: '200px' }}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#666' }}>
                    Account Type
                  </Typography>
                  <AccountTypeFilters />
                </Box>
                
                {!props.isAccountPage && (
                  <Box sx={{ flex: 1, minWidth: '200px' }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#666' }}>
                      Activity Status
                    </Typography>
                    <StatusFilters />
                  </Box>
                )}
              </Box>

              {/* Location Select Row */}
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#666' }}>
                  Location
                </Typography>
                <FormControl fullWidth>
                  <InputLabel id="propertyDropDownLabel">
                    Location{"  "}
                    {props.apl.isLoading && (
                      <CircularProgress size={15} m={0} />
                    )}
                  </InputLabel>
                  {property == "" && props.apl.isLoading ? (
                    <Select
                      labelId="propertyDropDownLabel"
                      id="propertyDropDown"
                      value={property}
                      className={classes.selectedPropertyLocationLabel}
                      onChange={handleSelectedPropertyChange}
                      fullWidth
                      disabled
                    >
                    </Select>
                  ) : (
                    <Select
                      labelId="propertyDropDownLabel"
                      id="propertyDropDown"
                      value={property}
                      className={classes.selectedPropertyLocationLabel}
                      onChange={handleSelectedPropertyChange}
                      fullWidth
                    >
                      {props.apl.data.propertyPreviews.length > 0 ? [
                        <MenuItem value={""}>All</MenuItem>,
                        props.apl.data.propertyPreviews.map((item, key) => {
                          return (
                            <MenuItem value={item.uuid} id={key}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      ] : [
                        <MenuItem value={-1}>No Properties Found</MenuItem>
                      ]
                      }
                    </Select>
                  )}
                </FormControl>
              </Box>
            </Box>
          </>
        )}
        {props.isAccountPage ? (
          <EditableTable
            readOnly={!canDisconnect}
            canAddItems={canDisconnect}
            canSave={false}
            manualItemDeletionMethod={deleteSelectedDisconnects}
            conditionalStylingMethod={conditionalStyling}
            isLoading={props.accountDisconnects.isLoading}
            newItemCreationMethod={show}
            handleRowClickParentMethod={onSelected}
            tableTitle={"Account Disconnects"}
            objectArray={props.accountDisconnects.data.accountDisconnectsList}
            currentActiveFilters={[propertyName]}
            fieldTitles={accountPage_fieldTitles}
            fieldTypes={accountPage_fieldTypes}
            fieldNames={accountPage_fieldNames}
            canExport={true}
            customUrlFields={urlFields}
            customChangePageRowsEvent={handleChangeRowsPerPage}
            customHandleChangePageEvent={handleChangePage}
            totalRowCount={props.accountDisconnects.accountDisconnectsTotalRows}
            conditionalOnSelectButtons={ConditionalOnSelectButtons}
          />
        )
          :
          (
            <EditableTable
              readOnly={!canDisconnect}
            canAddItems={canDisconnect}
              canSave={false}
              manualItemDeletionMethod={deleteSelectedDisconnects}
              conditionalStylingMethod={conditionalStyling}
              isLoading={props.accountDisconnects.isLoading}
              newItemCreationMethod={show}
              handleRowClickParentMethod={onSelected}
              tableTitle={"Account Disconnects"}
              objectArray={props.accountDisconnects.data.accountDisconnectsList}
              fieldTitles={fieldTitles}
              fieldTypes={fieldTypes}
              fieldNames={fieldNames}
              canExport={true}
              customUrlFields={urlFields}
              customChangePageRowsEvent={handleChangeRowsPerPage}
              customHandleChangePageEvent={handleChangePage}
              totalRowCount={props.accountDisconnects.accountDisconnectsTotalRows}
              conditionalOnSelectButtons={ConditionalOnSelectButtons}
            />
          )
        }
        <Grid
          container
          style={{ "justify-content": "end", "margin-top": "1em" }}
        ></Grid>
      </CardContent>
    </Card>
  );
}
// Component accountDisconnects
Table.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  accountDisconnects: PropTypes.object.isRequired,
  getAccountDisconnects: PropTypes.func.isRequired,
  processDisconnects: PropTypes.func.isRequired,
  deleteByUuid: PropTypes.func.isRequired,
};

// Component State
function State(state) {
  return {
    user: state.user,
    apl: state.apl,
    search: state.search,
    accountDisconnects: state.accountDisconnects,
    account: state.account,
  };
}
export default connect(State, {
  getAccountDisconnects,
  processDisconnects,
  deleteByUuid,
})(Table);
